module.exports = "/assets/landing-cf/hero/cocktail2x.jpg?q9jTw+z";